/* eslint eqeqeq: "off" */
import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import PropTypes from "prop-types";
import {
  Col,
  Row,
  Skeleton,
  Table,
  Select,
  AutoComplete,
  Input,
  Spin,
} from "antd";
import "./index.css";
import {
  CloseCircleOutlined,
  DownloadOutlined,
  DownOutlined,
} from "@ant-design/icons";
import { BiCalendar } from "react-icons/bi";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { isEmpty } from "lodash";
import useMedia from "use-media-antd-query";
import {
  loadBarcodeReportList,
  // loadBarcodeReportList,
  loadPurchaseInvoiceRecordsMetaData,
  // loadDashboardTransactions,
} from "../../store/reports/actions";
import DatePicker from "react-datepicker";
// import { load } from "../../store/items/actions";
import api from "../../helpers";
import { loadItems } from "../../store/items/actions";
import { ReactSearchAutocomplete } from "react-search-autocomplete";

const BarcodeDetailsReport = (props) => {
  const dispatch = useDispatch();
  // const { RangePicker } = DatePicker;

  //organisation id from login response
  const userValues = localStorage.getItem("authData");

  const userNameDetails = JSON.parse(userValues);

  // const userName = !isEmpty(userNameDetails) ? userNameDetails.user.name : "";
  // const userMobile = !isEmpty(userNameDetails)
  //   ? userNameDetails.user.mobileNo
  //   : "";
  const organizationId =
    !isEmpty(userNameDetails) &&
    userNameDetails.user &&
    userNameDetails.user.organizations.length > 0
      ? userNameDetails.user.organizations[0].organizationId
      : "";

  const media = useMedia();

  const barcodeGetPayload = {
    organizationId: organizationId,
    page: 1,
    limit: 10,
  };

  // console.log(userNameDetails, "userNameDetails");
  // console.log(userName, userMobile, "user values");
  //initial state values
  const [loading, setLoading] = useState(false);
  const [tableLoading, setTableLoading] = useState(false);
  const [barcodeClear, setBarcodeClear] = useState(false);
  const [barcodeList, setBarcodeList] = useState([]);
  const [modelList, setModelList] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [filteredValues, setFilteredValues] = useState({
    page: 1,
    limit: 10,
  });

  console.log(barcodeList, "barcodeList");
  //fuse options in venue name
  const fuseOptions = {
    keys: ["barcodeNo", "label"],
  };
  useEffect(() => {
    setLoading(true);
    setTableLoading(true);
    setTimeout(() => {
      setTableLoading(false);
      setLoading(false);
    }, 2000);

    dispatch(loadPurchaseInvoiceRecordsMetaData());
    dispatch(loadBarcodeReportList(barcodeGetPayload));
    dispatch(
      loadItems({
        organizationId: organizationId,
      })
    );
    // dispatch(loadbarcodeList());

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // reducer state
  const { barcode_report_list = [], recordsMetaData = {} } = useSelector(
    (state) => state.Reports
  );

  const { items_list = [] } = useSelector((state) => state.Items);
  const itemOptions =
    items_list && items_list.length > 0
      ? items_list.map((data) => {
          return { value: data._id, label: data.itemName };
        })
      : [];
  //header columns
  const HeaderData = [
    {
      key: "purchaseinvoiceDate",
      title: <p className="header-purchase-invoice font-semibold">Date</p>,
      dataIndex: "purchaseinvoiceDate",
      width: 120,
      // fixed: "left",
      sorter: (a, b) =>
        a.purchaseinvoiceDate.length - b.purchaseinvoiceDate.length,
    },
    // {
    //   key: "vendorName",
    //   title: (
    //     <p className="header-purchase-invoice font-semibold">Vendor Name</p>
    //   ),
    //   dataIndex: "vendorName",
    //   width: 150,
    // },
    // {
    //   key: "brandName",
    //   title: (
    //     <p className="header-purchase-invoice font-semibold">Brand Name</p>
    //   ),
    //   dataIndex: "brandName",
    //   width: 170,
    // },
    {
      key: "modelName",
      title: (
        <p className="header-purchase-invoice font-semibold">Model Name</p>
      ),
      dataIndex: "modelName",
      width: 170,
    },
    {
      key: "barCodeNo",
      title: (
        <p className="header-purchase-invoice font-semibold">Barcode No</p>
      ),
      dataIndex: "barCodeNo",
      width: 120,
    },
    {
      key: "ramName",
      title: <p className="header-purchase-invoice font-semibold">RAM Name</p>,
      dataIndex: "ramName",
      width: 120,
    },
    {
      key: "grade",
      title: <p className="header-purchase-invoice font-semibold">Grade</p>,
      dataIndex: "grade",
      width: 100,
    },
    {
      key: "purchasePrice",
      title: (
        <p className="header-purchase-invoice font-semibold">Purchase Price</p>
      ),
      dataIndex: "purchasePrice",
      width: 130,
    },
    {
      key: "sellingPrice",
      title: (
        <p className="header-purchase-invoice font-semibold">Selling Price</p>
      ),
      dataIndex: "sellingPrice",
      width: 120,
    },
  ];

  //filters

  const applyFilters = () => {
    var fromDateFilter = fromDate ? moment(fromDate).format("YYYY-MM-DD") : "";
    var toDateFilter = toDate ? moment(toDate).format("YYYY-MM-DD") : "";
    var barcodeFilter =
      barcodeList && barcodeList.value ? barcodeList.value : "";
    var modelFilter = modelList.length !== 0 ? modelList : "";

    let searchValue = {};
    searchValue.page = filteredValues.page ? filteredValues.page : 1;
    searchValue.limit = 10;
    searchValue.organizationId = organizationId;

    if (fromDateFilter) {
      searchValue.fromDate = fromDateFilter;
    }
    if (toDateFilter) {
      searchValue.toDate = toDateFilter;
    }
    if (barcodeFilter) {
      searchValue.Barcode = barcodeFilter;
    }
    if (modelFilter) {
      searchValue.itemId = modelFilter;
    }
    // setFilteredValues({
    //   page: "",
    //   limit: "",
    // });
    const searchFilterValues = Object.keys(searchValue).forEach(
      (data) => !searchValue[data] && delete searchValue[data]
    );
    console.log(searchFilterValues, "searchFilterValues");
    // console.log(searchValue, "searchValue");
    dispatch(loadBarcodeReportList(searchValue));
    setTableLoading(true);
    setTimeout(() => {
      setTableLoading(false);
    }, 2000);
  };

  // console.log(filteredValues, "filteredValues");

  const [barcodeReportRows, setBarcodeReportRows] = useState([
    {
      key: "",
      aging: "",
      barCodeNo: "",
      brandId: "",
      brandName: "",
      dateCreated: "",
      itemId: "",
      modelName: "",
      gradeId: "",
      grade: "",
      purchasePrice: "",
      purchaseinvoiceDate: "",
      purchaseinvoiceNo: "",
      ramName: "",
      sellingPrice: "",
      serialId: "",
      serialStatus: [],
      vendorId: "",
      vendorName: "",
    },
  ]);

  const barcodeReportDataTable =
    !isEmpty(barcode_report_list) &&
    barcode_report_list.paginatedData.length > 0
      ? barcode_report_list.paginatedData.map((data, index) => {
          return {
            key: index + 1,
            aging: data.aging ? (
              <div
                className={
                  data.aging > 30
                    ? "text-[#bb1d0d] font-semibold text-start"
                    : "text-[#08a35ae0] font-semibold text-start"
                }
              ></div>
            ) : (
              ""
            ),
            barCodeNo: data.barCodeNo,
            grade: data.gradeName,
            gradeId: data.gradeId,
            brandId: data.brandId,
            brandName: data.brandName,
            dateCreated: data.dateCreated,
            itemId: data.itemId,
            modelName: data.modelName,
            purchasePrice: data.purchasePrice,
            purchaseinvoiceDate: data.dateCreated
              ? moment(data.dateCreated).format("DD-MM-YYYY")
              : "",
            purchaseinvoiceNo: data.purchaseinvoiceNo,
            ramName: data.ramName,
            sellingPrice: data.sellingPrice ? data.sellingPrice : 0,
            serialId: data.serialId,
            serialStatus: data.serialStatus,
            vendorId: data.vendorId,
            vendorName: data.vendorName,
            status: data.status,
          };
        })
      : [];

  //Calculate totals
  const calculateTotals = (rows) => {
    let purchasePrice = 0;
    let sellingPrice = 0;

    rows.forEach((row) => {
      purchasePrice += parseFloat(row.purchasePrice) || 0;
      sellingPrice += parseFloat(row.sellingPrice) || 0;
    });

    return { purchasePrice, sellingPrice };
  };

  const [totals, setTotals] = React.useState({
    purchasePrice: 0,
    sellingPrice: 0,
  });

  useEffect(() => {
    if (barcodeReportDataTable && barcodeReportDataTable.length > 0) {
      setBarcodeReportRows(barcodeReportDataTable);
      const total = calculateTotals(barcodeReportDataTable);
      setTotals(total);
    } else {
      setBarcodeReportRows([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [barcode_report_list]);

  //paginations
  const handlePagination = (data) => {
    // console.log(data);
    setFilteredValues({
      page: data,
      limit: 10,
    });
    dispatch(
      loadBarcodeReportList({
        page: data,
        limit: 10,
        organizationId: organizationId,
      })
    );
    setTableLoading(true);
    setTimeout(() => {
      setTableLoading(false);
    }, 2000);
  };

  //search , print and download
  const [search, setSearch] = useState("");

  const handleSearch = (event) => {
    const filteredRows = barcodeReportDataTable
      .filter((row) =>
        row.modelName.toLowerCase().includes(event.target.value.toLowerCase())
      )
      .filter((item, index, self) => self.indexOf(item) === index); // Remove duplicates

    setSearch(event.target.value);
    setBarcodeReportRows(filteredRows);
    setTableLoading(true);
    setTimeout(() => {
      setTableLoading(false);
    }, 2000);
  };

  //Download functionality

  //Download functionality
  const downloadFile = ({ data, fileName, fileType }) => {
    const blob = new Blob([data], { type: fileType });

    const a = document.createElement("a");
    a.download = fileName;
    a.href = window.URL.createObjectURL(blob);
    const clickEvt = new MouseEvent("click", {
      view: window,
      bubbles: true,
      cancelable: true,
    });
    a.dispatchEvent(clickEvt);
    a.remove();
  };

  const handleDownloadPDF = () => {
    setDownloadLoading(true);

    let searchValue = {};
    searchValue.organizationId = organizationId;
    // setFilteredValues({
    //   page: "",
    //   limit: "",
    // });

    api
      .post(`/org/barcodereportsexcel`, searchValue)
      .then((response) => {
        // console.log(response.data, "response");

        const stockReportExcel =
          !isEmpty(response) && response.data.length > 0
            ? response.data.map((data, index) => {
                return {
                  key: index + 1,
                  aging: data.aging ? (
                    <div
                      className={
                        data.aging > 30
                          ? "text-[#bb1d0d] font-semibold text-start"
                          : "text-[#08a35ae0] font-semibold text-start"
                      }
                    ></div>
                  ) : (
                    ""
                  ),
                  barCodeNo: data.barCodeNo,
                  grade: data.gradeName,
                  gradeId: data.gradeId,
                  brandId: data.brandId,
                  brandName: data.brandName,
                  dateCreated: data.dateCreated,
                  itemId: data.itemId,
                  modelName: data.modelName,
                  purchasePrice: data.purchasePrice,
                  purchaseinvoiceDate: data.dateCreated
                    ? moment(data.dateCreated).format("DD-MM-YYYY")
                    : "",
                  purchaseinvoiceNo: data.purchaseinvoiceNo,
                  ramName: data.ramName,
                  sellingPrice: data.sellingPrice,
                  serialId: data.serialId,
                  serialStatus: data.serialStatus,
                  vendorId: data.vendorId,
                  vendorName: data.vendorName,
                  status: data.status,
                };
              })
            : [];
        setTimeout(() => {
          let headerData = [
            "S.No, Date,Model Name,Barcode No,RAM, Grade, Purchase Price,Selling Price",
          ];

          let usersCsv = !isEmpty(stockReportExcel)
            ? stockReportExcel.reduce((acc, user) => {
                const {
                  key,
                  purchaseinvoiceDate,
                  modelName,
                  barCodeNo,
                  ramName,
                  grade,
                  sellingPrice,
                  purchasePrice,
                } = user;
                acc.push([
                  key,
                  purchaseinvoiceDate,
                  modelName,
                  barCodeNo,
                  ramName,
                  grade,
                  sellingPrice,
                  purchasePrice,
                ]);

                // console.log("test", acc);
                return acc;
              }, [])
            : false;
          // console.log(usersCsv, "usersCsv");

          const usersList =
            !isEmpty(usersCsv) && usersCsv.length > 0 ? usersCsv : [];

          downloadFile({
            data: [...headerData, ...usersList].join("\n"),
            fileName: "BarcodeDetailsReport.csv",
            fileType: "text/csv",
          });
          setDownloadLoading(false);
        }, 2500);
        return response.data;
      })
      .catch((error) => Promise.reject(error));
  };

  //window height/width
  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <React.Fragment>
      <div className="">
        <MetaTags>
          <title>Barcode Details Report | Mbook</title>
        </MetaTags>
      </div>

      <Row className="border-solid rounded-sm bg-[#ffffff]">
        <Col span={24}>
          <div className="font-poppins border border-b-1 border-x-0 border-t-0 pl-[20px] pr-[20px] mt-2 pb-2">
            <div className="flex">
              <h1
                style={{
                  fontFamily: "Poppins",
                }}
                className="text-[16px] font-semibold"
              >
                Barcode Details Report
              </h1>
            </div>
          </div>
        </Col>
      </Row>
      <Row
        className={
          (windowDimensions.height >= 700 && windowDimensions.height <= 767) ||
          (windowDimensions.height > 767 && windowDimensions.height < 830)
            ? "add-ledger-statment-reports-large-device"
            : windowDimensions.height > 830 && windowDimensions.height < 1000
            ? "add-ledger-statment-reports-extra-large-device"
            : windowDimensions.height >= 1000
            ? "add-ledger--barcode-statment-reports-large-device"
            : "add-ledger-statment-reports"
        }
      >
        <Col
          span={24}
          className="mt-2 pr-4 pl-4 pt-3 pb-2 mb-4 bg-[#ffffff] rounded-md"
        >
          <Row className="pr-2 pl-2 pt-3 pb-2 rounded-md">
            <Col md={6} lg={6} sm={24} xs={24} className="pr-3">
              {loading ? (
                <Skeleton.Input
                  style={{
                    width:
                      media == "md"
                        ? "180px"
                        : media == "sm"
                        ? "300px"
                        : "250px",
                    height: "35px",
                  }}
                ></Skeleton.Input>
              ) : (
                <ReactSearchAutocomplete
                  name="barcode"
                  key={barcodeClear}
                  items={recordsMetaData ? recordsMetaData.barcodeOptions : []}
                  value={barcodeList}
                  type="autoComplete"
                  resultStringKeyName="label"
                  showIcon={false}
                  onChange={(e) => setBarcodeList(e.target.value)}
                  onSelect={(e) => {
                    setBarcodeList(e);
                    console.log(e, "barcodeList");
                  }}
                  showClear
                  placeholder="Scan barcode"
                  fuseOptions={fuseOptions} // Search on both fields
                  className="text-end hover:bg-[#e9ecf1] focus:bg-[#e9ecf1] mb-[-6px]"
                  styling={{
                    height: "38px",
                    border: "1px solid #ced4da",
                    borderRadius: "4px",
                    backgroundColor: "white",
                    boxShadow: "none",
                    textAlign: "end",
                    hoverBackgroundColor: "lightgray",
                    color: "black",
                    // marginBottom: "-3px",
                    fontSize: "12px",
                    fontFamily: "Poppins",
                    iconColor: "green",
                    clearIconMargin: "3px 8px 0 0",
                    zIndex: 10,
                  }}
                />
                // <Select
                //   value={barcodeList}
                //   onChange={(newValue) => setBarcodeList(newValue)}
                //   placeholder="Select Barcode"
                //   // mode="multiple"
                //   options={
                //     recordsMetaData ? recordsMetaData.barcodeOptions : []
                //   }
                //   className={
                //     media == "sm"
                //       ? "w-[366px] h-[40px]"
                //       : media == "xs"
                //       ? "w-[230px] h-[40px]"
                //       : "w-[100%] h-[40px]"
                //   }
                // />
              )}
            </Col>
            <Col md={6} lg={6} sm={24} xs={24} className="pr-3">
              {loading ? (
                <Skeleton.Input
                  style={{
                    width:
                      media == "md"
                        ? "180px"
                        : media == "sm"
                        ? "300px"
                        : "250px",
                    height: "35px",
                    marginTop: media == "sm" || media == "xs" ? "6px" : "",
                  }}
                ></Skeleton.Input>
              ) : (
                <Select
                  value={modelList}
                  onChange={(value) => setModelList(value)}
                  placeholder="Select Model"
                  // mode="multiple"
                  options={itemOptions}
                  suffixIcon={
                    !isEmpty(modelList) ? (
                      <CloseCircleOutlined onClick={() => setModelList([])} />
                    ) : (
                      <DownOutlined />
                    )
                  }
                  allowClear
                  // menuItemSelectedIcon
                  onClear={() => setModelList([])}
                  className={
                    media == "sm"
                      ? "w-[366px] h-[40px] mt-2"
                      : media == "xs"
                      ? "w-[230px] h-[40px] mt-2"
                      : "w-[100%] h-[40px]"
                  }
                />
              )}
            </Col>
            <Col md={5} lg={5} sm={24} xs={24} className="pr-3">
              {loading ? (
                <Skeleton.Input
                  style={{
                    width:
                      media == "md"
                        ? "180px"
                        : media == "sm"
                        ? "300px"
                        : "250px",
                    height: "35px",
                    marginTop: media == "sm" || media == "xs" ? "6px" : "",
                  }}
                ></Skeleton.Input>
              ) : (
                <DatePicker
                  selected={fromDate}
                  className={
                    media == "sm"
                      ? "rounded-md border border-1 h-[40px] w-[200%] mt-2"
                      : media == "xs"
                      ? "rounded-md border border-1 h-[40px] w-[125%] mt-2"
                      : media == "lg" || media == "md"
                      ? "rounded-md border border-1 h-[40px] w-[100%]"
                      : "rounded-md border border-1 h-[40px] w-[110%]"
                  }
                  toggleCalendarOnIconClick={true}
                  onChange={(date) => setFromDate(date)}
                  icon={
                    <BiCalendar
                      //   size={30}
                      className={
                        media == "sm"
                          ? "top-[12px] text-[16px] right-[-183px] text-[#9e9e9e]"
                          : media == "xs"
                          ? "top-[12px] text-[16px] right-[-30px] text-[#9e9e9e]"
                          : media == "md" || media == "lg"
                          ? "top-[5px] text-[16px] right-[3px] text-[#9e9e9e]"
                          : "top-[5px] text-[16px] right-[-20px] text-[#9e9e9e]"
                      }
                    />
                  }
                  popperClassName={"z-10 ml-3"}
                  showIcon
                  placeholderText="Select From Date"
                />
              )}
            </Col>
            <Col md={5} lg={5} sm={24} xs={24} className="pr-3">
              {loading ? (
                <Skeleton.Input
                  style={{
                    width:
                      media == "md"
                        ? "180px"
                        : media == "sm"
                        ? "300px"
                        : "250px",
                    height: "35px",
                    marginTop: media == "sm" || media == "xs" ? "6px" : "",
                  }}
                ></Skeleton.Input>
              ) : (
                <DatePicker
                  selected={toDate}
                  className={
                    media == "sm"
                      ? "rounded-md border border-1 h-[40px] w-[200%] mt-2"
                      : media == "xs"
                      ? "rounded-md border border-1 h-[40px] w-[125%] mt-2"
                      : media == "lg" || media == "md"
                      ? "rounded-md border border-1 h-[40px] w-[100%]"
                      : "rounded-md border border-1 h-[40px] w-[110%]"
                  }
                  toggleCalendarOnIconClick={true}
                  onChange={(date) => setToDate(date)}
                  icon={
                    <BiCalendar
                      //   size={30}
                      className={
                        media == "sm"
                          ? "top-[12px] text-[16px] right-[-183px] text-[#9e9e9e]"
                          : media == "xs"
                          ? "top-[12px] text-[16px] right-[-30px] text-[#9e9e9e]"
                          : media == "md" || media == "lg"
                          ? "top-[5px] text-[16px] right-[3px] text-[#9e9e9e]"
                          : "top-[5px] text-[16px] right-[-20px] text-[#9e9e9e]"
                      }
                    />
                  }
                  popperClassName={"z-10 ml-3"}
                  showIcon
                  placeholderText="Select To Date"
                />
                // <RangePicker
                //   style={{
                //     width: "100%",
                //     height: 40,
                //   }}
                //   onChange={(date, dateString) => {
                //     console.log(date, "date");
                //     setSelectDays(dateString);
                //     if (dateString) {
                //       const startMonth =
                //         dateString && dateString.length > 0
                //           ? dateString[0]
                //           : "";
                //       const endMonth =
                //         dateString && dateString.length > 0
                //           ? dateString[1]
                //           : "";
                //       const ledgerStatementData = {
                //         organizationId: props.organizationId,
                //         partyorvendorId: props.partyId,
                //         dateFrom: startMonth,
                //         dateTo: endMonth,
                //       };
                //       setStockReportData({
                //         ...stockReportData,
                //         startMonth: startMonth,
                //         endMonth: endMonth,
                //       });
                //     }
                //   }}
                //   allowClear
                //   suffixIcon={<BiCalendar size={18} />}
                //   placeholder="Select Calendar"
                //   className="ml-2"
                // />
              )}
            </Col>
            <Col md={24} lg={24} sm={24} xs={24} className="pr-2 mt-3">
              <Row
                className={
                  media == "sm" || media == "xs" ? "flex" : "flex justify-end"
                }
              >
                {loading ? (
                  <Skeleton.Input
                    style={{
                      width:
                        media == "md"
                          ? "180px"
                          : media == "sm"
                          ? "300px"
                          : "250px",
                      height: "35px",
                    }}
                  ></Skeleton.Input>
                ) : (
                  <div className="flex">
                    <div
                      style={{
                        fontFamily: "Poppins",
                        fontSize: "13px",
                      }}
                      onClick={() => {
                        setFromDate("");
                        setToDate("");
                        setBarcodeList([]);
                        setModelList([]);
                        dispatch(loadBarcodeReportList(barcodeGetPayload));
                        setTableLoading(true);
                        setBarcodeClear(true);
                        setTimeout(() => {
                          setBarcodeClear(false);
                        }, 0);
                        setTimeout(() => {
                          setTableLoading(false);
                        }, 2000);
                      }}
                      className={
                        media == "sm" || media == "xs"
                          ? "cursor-pointer ml-0 text-[#ffffff] text-center rounded-md pt-2 pb-2 pl-5 pr-5 mr-2 bg-[#eb4d1b] hover hover:bg-[red]"
                          : "cursor-pointer ml-5 text-[#ffffff] text-center rounded-md pt-2 pb-2 pl-5 pr-5 mr-2 bg-[#eb4d1b] hover hover:bg-[red]"
                      }
                    >
                      Reset
                    </div>
                    <div
                      style={{
                        fontFamily: "Poppins",
                        fontSize: "13px",
                      }}
                      onClick={() => applyFilters()}
                      className="cursor-pointer ml-1 text-[#ffffff] text-center rounded-md pt-2 pb-2 pl-5 pr-5 bg-[#45bd4a] hover hover:bg-[green]"
                    >
                      Filter
                    </div>
                  </div>
                )}
              </Row>
            </Col>
          </Row>
        </Col>
        {/* print, download section */}
        <Col
          md={24}
          lg={24}
          sm={24}
          xs={24}
          className="bg-[#ffffff] rounded-md"
        >
          <Row className="flex flex-col">
            <Col md={24} lg={24} sm={24} xs={24} className="mt-4 mb-3 pb-5">
              <Row className="flex justify-between">
                <Col
                  md={10}
                  lg={10}
                  sm={24}
                  xs={24}
                  className="pr-3 lg:pr-0 md:pr-0 pl-4"
                >
                  {loading ? (
                    <Skeleton.Input
                      style={{
                        width:
                          media == "md"
                            ? "180px"
                            : media == "sm"
                            ? "300px"
                            : "180px",
                        height: "35px",
                      }}
                    ></Skeleton.Input>
                  ) : (
                    <div className="w-[100%] lg:w-[65%] md:w-[65%]">
                      <AutoComplete
                        style={{
                          marginRight: "10px",
                          fontSize: "11px",
                        }}
                        // onClick={() => setSearchOpen(false)}
                        className="w-[100%]"
                      >
                        <Input.Search
                          size="middle"
                          placeholder="Search Model"
                          style={{
                            fontFamily: "Poppins",
                            // minHeight: "35px",
                            fontSize: "11px",
                          }}
                          name="search"
                          value={search}
                          onChange={(e) => handleSearch(e)}
                        />
                      </AutoComplete>
                    </div>
                  )}
                </Col>
                <Col md={14} lg={14} sm={24} xs={24} className="pr-1">
                  <Row className="flex justify-end">
                    <Col
                      md={7}
                      lg={7}
                      sm={24}
                      xs={24}
                      className="pr-3 sm:pr-3 ml-3 sm:ml-3 mt-3 lg:mt-0 md:mt-0 lg:ml-10 md:ml-10"
                    >
                      {loading ? (
                        <Skeleton.Input
                          style={{
                            width:
                              media == "md"
                                ? "180px"
                                : media == "sm"
                                ? "300px"
                                : "180px",
                            paddingRight: media == "md" ? "20px" : "14px",
                            height: "35px",
                          }}
                        ></Skeleton.Input>
                      ) : (
                        <Row>
                          <Col
                            md={24}
                            lg={24}
                            sm={24}
                            xs={24}
                            onClick={handleDownloadPDF}
                            className={
                              media == "sm" || media == "xs"
                                ? "cursor-pointer border pt-[5px] pb-[5px] ml-3 mr-3 rounded-md border-1"
                                : // ? "cursor-pointer border pt-[5px] pb-[5px] ml-3 mr-2 rounded-md border-1"
                                  "cursor-pointer border pt-[5px] pb-[5px] rounded-md border-1"
                              // : "cursor-pointer border pt-[5px] pb-[5px] sm:pl-[5px] md:pl-[10px] pl-[5px] lg:pl-[40px] xl:pl-[40px] xxl:pl-[40px] pr-[30px] rounded-md border-1"
                            }
                            style={{
                              fontFamily: "Poppins",
                            }}
                          >
                            {downloadLoading ? (
                              <p className="flex">
                                {" "}
                                <Spin className="mr-2" /> Downloading
                              </p>
                            ) : (
                              <p
                                className={
                                  media == "sm" || media == "xs"
                                    ? "flex justify-center"
                                    : "flex justify-center"
                                }
                              >
                                <DownloadOutlined className="text-[16px] mr-3" />{" "}
                                Download
                              </p>
                            )}
                          </Col>
                        </Row>
                      )}
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>

            <Col
              span={24}
              className={
                media === "xxl"
                  ? "pt-8 pl-4 purchase-invoice-orders"
                  : "pr-1 pl-4 purchase-invoice-orders"
              }
            >
              <Table
                style={{
                  overflow: "hidden",
                }}
                bordered
                columns={HeaderData}
                dataSource={
                  barcodeReportRows &&
                  barcodeReportRows.length > 0 &&
                  !isEmpty(barcodeReportRows[0].modelName)
                    ? barcodeReportRows
                    : []
                }
                rowClassName={"table-row-label p-0"}
                expandable={{
                  // expandedRowRender: expandedRowRender,
                  defaultExpandAllRows: false,
                  // expandIconColumnIndex: 5,
                }}
                pagination={{
                  defaultPageSize: 10,
                  showSizeChanger: true,
                  onShowSizeChange: (e) => console.log(e, "page limit"),
                  pageSizeOptions: ["5", "10", "20", "30"],
                  onChange: (e) => handlePagination(e),
                  // page
                  total: !isEmpty(search)
                    ? barcodeReportRows.length
                    : barcode_report_list
                    ? barcode_report_list.totalItems
                    : "",
                  showTotal: (total, pageSize) => {
                    const indexOfLastRow =
                      pageSize && pageSize.length > 0 && pageSize[1];
                    const indexOfFirstRow =
                      pageSize && pageSize.length > 0 && pageSize[0];

                    return (
                      <p
                        style={{
                          fontFamily: "Poppins",
                          fontSize: "12px",
                        }}
                      >
                        Showing rows {indexOfFirstRow} to {indexOfLastRow} of{" "}
                        {!isEmpty(search)
                          ? barcodeReportRows.length
                          : barcode_report_list
                          ? barcode_report_list.totalItems
                          : total}
                      </p>
                    );
                  },
                }}
                footer={() => {
                  return (
                    <div className="flex flex-row mt-[-18px] mb-[-15px]">
                      <div className="pr-4 w-[73.8%] flex justify-end">
                        <h1
                          style={{
                            fontFamily: "Poppins",
                          }}
                          className="text-[16px] mt-2 font-semibold"
                          // className="w-[66%] md:w-[65%] lg:w-[65%] xl:w-[65%] xxl:w-[65%] text-[14px] mt-1 font-semibold"
                        >
                          Total
                        </h1>
                        <p className="ml-4 h-10 w-[0.2px] text-[#ebe8e8] bg-[#ebe8e8]"></p>
                      </div>
                      <div className="flex justify-between w-[13.6%] pl-1">
                        <div className="flex mt-2">
                          <p className="font-semibold">{"₹"}</p>
                          <h1
                            style={{
                              fontFamily: "Poppins",
                            }}
                            className="text-[14px] ml-1 font-semibold"
                          >
                            {barcodeReportDataTable.length > 0 &&
                            totals.purchasePrice &&
                            totals.purchasePrice
                              ? totals.purchasePrice.toLocaleString("en-IN")
                              : 0}
                          </h1>
                        </div>
                        <p className="ml-4 h-10 w-[0.2px] text-[#ebe8e8] bg-[#ebe8e8]"></p>
                      </div>
                      <div className="flex w-[11.5%] pl-2 pt-2">
                        <p className="font-semibold">{"₹"}</p>
                        <h1
                          style={{
                            fontFamily: "Poppins",
                          }}
                          className="text-[14px] ml-1 font-semibold"
                        >
                          {barcodeReportDataTable.length > 0 &&
                          totals.sellingPrice &&
                          totals.sellingPrice
                            ? totals.sellingPrice.toLocaleString("en-IN")
                            : 0}
                        </h1>
                      </div>
                    </div>
                  );
                }}
                sortDirections={"ascend"}
                loading={tableLoading ? true : false}
                showSorterTooltip={"sorter-icon"}
                scroll={{ x: 825 }}
                // scroll={{ y: "100%", x: 825 }}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </React.Fragment>
  );
};

BarcodeDetailsReport.propTypes = {
  location: PropTypes.any,
  itemId: PropTypes.any,
  organizationId: PropTypes.any,
  partyName: PropTypes.any,
  ledgerLoading: PropTypes.any,
};

export default BarcodeDetailsReport;
